/**
 * Client mirror of backend db/proposals.js computeTotals (2026-09-07).
 *
 * The SERVER total is canonical — every save round-trips and the
 * editor re-renders from the response. This copy exists so the quote
 * editor can show a live number while the seller types, and so the
 * buyer's optional-line toggles update the total before the server
 * confirms. It must round exactly the way the server does: per line,
 * in integer cents, at each step (subtotal → discount → tax), so the
 * lines a person reads always sum to the total they read.
 *
 * Accepts either the API's camelCase line shape or the editor's draft
 * rows (same keys). A required line is always counted; only an
 * optional line carries a buyer-toggleable selection.
 */
export function computeTotals(items) {
  let subtotalCents = 0;
  let discountCents = 0;
  let taxCents = 0;
  let optionalUnselectedCents = 0;
  const lines = [];
  for (const it of items || []) {
    const qty = Number(it.quantity ?? 1);
    const unit = Number(it.unitPriceCents ?? 0);
    const discPct = Number(it.discountPct ?? 0);
    const taxPct = Number(it.taxRatePct ?? 0);
    const optional = !!it.isOptional;
    const selected = optional ? (it.selected === undefined ? true : !!it.selected) : true;

    const lineSubtotal = Math.round(qty * unit);
    const lineDiscount = Math.round(lineSubtotal * discPct / 100);
    const taxable = lineSubtotal - lineDiscount;
    const lineTax = Math.round(taxable * taxPct / 100);
    const lineTotal = taxable + lineTax;

    lines.push({
      id: it.id || null,
      counted: selected,
      lineSubtotalCents: lineSubtotal,
      lineDiscountCents: lineDiscount,
      lineTaxCents: lineTax,
      lineTotalCents: lineTotal,
    });
    if (selected) {
      subtotalCents += lineSubtotal;
      discountCents += lineDiscount;
      taxCents += lineTax;
    } else {
      optionalUnselectedCents += lineTotal;
    }
  }
  return {
    subtotalCents,
    discountCents,
    taxCents,
    totalCents: subtotalCents - discountCents + taxCents,
    optionalUnselectedCents,
    lines,
  };
}
